import PAImage from "component/design-system/images/PAImage";
import GarageDropdownWrapper from "container/header/GarageDropdownWrapper";
import { createMakeImageSource } from "util/vehicle/createMakeImageSource";
import { createVehicleDescription } from "util/vehicle/createVehicleDescription";
import styles from "./vehicleSelectorSelected.module.scss";

function VehicleSelectorSelected(props: any) {
  const { selectedVehicle } = props;
  const vehicleDes = createVehicleDescription(selectedVehicle);

  return (
    <div className={styles.grid_item}>

      <div className={`${styles.imageWrapper} ${styles.garage} `}>

        <PAImage
          alt={vehicleDes}
          src={createMakeImageSource(selectedVehicle)}
          width={40}
          height={40}
        />
      </div>

      <GarageDropdownWrapper darkIcon applyGarageDropdownClass />
    </div>
  );
}

export default VehicleSelectorSelected;
